// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("../../../../../../public/icons/date.svg", import.meta.url);
// Module
var code = `<div class="transaction-item"> <div class="type"> <img id="transaction-icon" width="35"/> <span id="transaction-type"></span> </div> <div class="date"> <div> <img src="${___HTML_LOADER_IMPORT_0___}" width="25" alt=""/> </div> <span id="transaction-date"></span> </div> <div class="amount" id="transaction-amount"></div> </div> `;
// Exports
export default code;